import { useCropsOptions } from "../../lib/hooks";
import { SelectField, SelectFieldProps } from "../form";

export function CropSelect({
  onlyUsed,
  ...props
}: SelectFieldProps & { onlyUsed?: boolean }) {
  return (
    <SelectField
      optionsHook={useCropsOptions}
      optionsHookParams={{ variables: { filter: { onlyUsed } } }}
      {...props}
    />
  );
}
